import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { LoadOptions } from 'app/types-shared';

export const ACTION = {
  REQUEST_CODETABLE: 'INDICATOR_FACTORS:REQUEST_CODETABLE',
  RECEIVE_CODETABLE: 'INDICATOR_FACTORS:RECEIVE_CODETABLE',
  FAIL_CODETABLE: 'INDICATOR_FACTORS:FAIL_CODETABLE'
};

export class RequestCodetable {
  public type: string = ACTION.REQUEST_CODETABLE;
  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ReceiveCodetable {
  public type: string = ACTION.RECEIVE_CODETABLE;

  constructor(public id: string, public loadOptionsParams: LoadOptions,
    public codes: CodeComplexValue<number>[], public currentOptions: CodeComplexValue<number>[]) {
  }
}

export class FailCodetable {
  public type: string = ACTION.FAIL_CODETABLE;

  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}
